import { createSlice } from "@reduxjs/toolkit";
import { ReportViewerType } from "../../../components/ReportViewer/ReportViewer.types";
import {
  InspectionReportType,
  SummaryReportDownloadStatusType,
} from "./StandardsSummaryReport.types";

const initialState = {
  InspectionReport: {} as ReportViewerType,
  excelReportStatus: [],
} as InspectionReportType;

const inspectionReportPageSlice = createSlice({
  name: "InspectionReport",
  initialState: initialState,
  reducers: {
    setInspectionReportData: (
      state,
      action: { payload: InspectionReportType }
    ) => {
      return {
        ...state,
        InspectionReport: action.payload?.InspectionReport,
      };
    },
    setIsReportReady: (state, action: { payload: boolean }) => {
      return { ...state, isReady: action.payload };
    },
    setIsXLAllIsReady: (state, action: { payload: boolean }) => {
      return { ...state, isReadyAllXL: action.payload };
    },
    setExcelReportStatus: (
      state,
      action: { payload: SummaryReportDownloadStatusType }
    ) => {
      const tempList = [...state.excelReportStatus];
      const index = tempList.findIndex(
        (summary) => summary.InspectionId === action.payload.InspectionId
      );

      if (index !== -1) {
        tempList[index] = {
          ...tempList[index],
          ...({
            InspectionId: action.payload.InspectionId,
            IsDownloading: action.payload.IsDownloading,
          } as SummaryReportDownloadStatusType),
        };
      } else {
        tempList.push({
          InspectionId: action.payload.InspectionId,
          IsDownloading: action.payload.IsDownloading,
        } as SummaryReportDownloadStatusType);
      }

      return { ...state, excelReportStatus: tempList };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const inspectionReportReducerActions = inspectionReportPageSlice.actions;
export const inspectionReportReducer = inspectionReportPageSlice.reducer;
